<app-loader [Parent]="this"></app-loader>
@if (FormLoaded == true) {
  <div [formGroup]="Form">
    <app-pageheader [Parent]="this">
      <app-form-save-button (OnSave)="Save()" [Parent]="this" [Form]="Form"></app-form-save-button>
    </app-pageheader>
    <!-- <app-validationsummary [Form]="Form"></app-validationsummary> -->
    <app-tabs>
      <app-tab Title="Area">
        <div class="columns">
          <div class="column">
            <app-field Label="Area Name">
              <div class="control">
                <input formControlName="Name" class="input is-short" type="text" placeholder="Name" name="Name" />
                <app-validator [For]="this.Form.get('Name')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Payment Grace" [HasAddons]="true" tippy="The grace period after paying in which a vehicle will be allowed to exit without recalculating the fee">
              <div class="control">
                <input formControlName="SessionExitTimeMinutes" class="input is-short" type="number" placeholder="Select Minutes"
                  name="SessionExitTimeMinutes" />
                  <app-validator [For]="this.Form.get('SessionExitTimeMinutes')"></app-validator>
                </div>
                <div class="control">
                  <a class="button is-default">Minutes</a>
                </div>
              </app-field>
              <app-field Label="Entry Grace" [HasAddons]="true" tippy="The grace period after entering the area in which a vehicle will be allowed to exit without calculating a fee.">
                <div class="control">
                  <input formControlName="EntryGraceTimeMinutes" class="input is-short" type="number" placeholder="Select Minutes"
                    name="EntryGraceTimeMinutes" />
                    <app-validator [For]="this.Form.get('EntryGraceTimeMinutes')"></app-validator>
                  </div>
                  <div class="control">
                    <a class="button is-default">Minutes</a>
                  </div>
                </app-field>
                <app-field Label="Auto-Expire Sessions" [HasAddons]="true">
                  <div class="control">
                    <input formControlName="SessionExpiryHours" class="input is-short" type="number" placeholder="Select Hours"
                      name="SessionExpiryHours" />
                      <app-validator [For]="this.Form.get('SessionExpiryHours')"></app-validator>
                    </div>
                    <div class="control">
                      <a class="button is-default">Hours</a>
                    </div>
                  </app-field>
                  <app-field Label="Default Fee">
                    <div class="control">
                      <app-currency-input formControlName="DefaultFee" placeholder="not set" name="DefaultFee">
                      </app-currency-input>
                      <app-validator [For]="this.Form.get('DefaultFee')"></app-validator>
                    </div>
                  </app-field>
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">Parking Lots</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control" formArrayName="ParkingLots">
                          <table class="table is-striped is-bordered is-fullwidth">
                            <thead>
                              <tr>
                                <th style="width: 2em">Links</th>
                                <th>Parking Lot</th>
                                <th>Spaces</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (p of FormArray(Form, 'ParkingLots').controls; track p; let i = $index) {
                                <tr>
                                  <td class="link-cell">
                                    @for (linkedLot of GetLinkedParkingLots(p); track linkedLot) {
                                      @if (GetLinkPosition(p, linkedLot).isFirst) {
                                        <div class="parking-lot-connection"
                                          [style.height.%]="(GetLinkPosition(p, linkedLot).rowSpan - 1) * 100"
                                          [class.adjustable]="IsLinkAdjustable(p, linkedLot)">
                                          <div class="connection-line"></div>
                                          <div class="connection-icon" (click)="OpenSpaceAllocationModal(p.get('Id')?.value, linkedLot.get('Id')?.value)">
                                            <i class="fa fa-link"></i>
                                          </div>
                                        </div>
                                      }
                                    }
                                  </td>
                                  <td><a [routerLink]="['/parking/parking/lots/', p.get('Id')?.value]">{{p.get('Name')?.value}}</a></td>
                                  <td>{{p.get('TotalSpaces')?.value}}</td>
                                  <td style="width:1em">
                                    <button type="button" (click)="RemoveParkingLot(i)" class="button is-danger is-small">
                                      <i class="fa fa-trash"></i>
                                    </button>
                                  </td>
                                </tr>
                              }
                            </tbody>
                            <tfoot>
                              <tr>
                                <td colspan="99">
                                  <button class="button is-primary is-outlined is-fullwidth" (click)="AddParkingLot()">Add Parking Lot</button>
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="field is-horizontal">
                    <div class="field-label is-normal">
                      <label class="label">Access Control</label>
                    </div>
                    <div class="field-body">
                      <div class="field">
                        <div class="control">
                          <table class="table is-striped is-bordered is-fullwidth">
                            <thead>
                              <tr>
                                <th>Priority</th>
                                <th>Access Method</th>
                                <th>Charge Strategy</th>
                                <th>Applies To</th>
                                <th></th>
                              </tr>
                            </thead>
                            @for (p of FormArray(Form, 'AccessMethods').controls; track p; let i = $index) {
                              <tbody formArrayName="AccessMethods"
                                >
                                <tr [formGroupName]="i">
                                  <td style="vertical-align: middle;" class="is-fullheight">
                                    <div class="columns ">
                                      <div class="column is-8" style="position: relative">
                                        @if (i!=0) {
                                          <a class="up-button" (click)="MoveUp(i)" title="Move Up">
                                            <i class="fa fa-chevron-up" aria-hidden="true"></i>
                                          </a>
                                        }
                                        @if (i!=FormArray(Form,'AccessMethods').controls.length - 1) {
                                          <a class="down-button"  (click)="MoveDown(i)" title="Move Down">
                                            <i class="fa fa-chevron-down" aria-hidden="true"></i>
                                          </a>
                                        }
                                      </div>
                                      <div class="column">
                                        {{i+1}}
                                      </div>
                                    </div>
                                  </td>
                                  <td>{{p.get('AccessMethodDescription')?.value}}</td>
                                  <td>{{p.get('ChargeStrategyDescription')?.value}}</td>
                                  <td>{{p.get('TargetDescription')?.value}}</td>
                                  <td style="width:1em;  vertical-align: middle;">
                                    <div class="level ">
                                      <button type="button" (click)="EditAccessMethod(p)"
                                        class="button is-link is-small ng-star-inserted level-item mr-1">
                                        <i class="fa fa-chevron-right"></i></button>
                                        <button type="button" (click)="RemoveAccessMethod(i)"
                                          class="button is-danger is-small ng-star-inserted  level-item "><i
                                        class="fa fa-trash"></i></button>
                                      </div>
                                    </td>
                                    <!-- <td style="width:1em">
                                    <button type="button" (click)="RemoveAccessMethod(i)"
                                      class="button is-danger is-small ng-star-inserted"><i class="fa fa-trash"></i></button></td> -->
                                    </tr>
                                  </tbody>
                                }
                                <tfoot>
                                  <tr>
                                    <td colspan="99">
                                      <button class="button is-primary is-outlined is-fullwidth" (click)="AddAccessMethod()">Add Access Method</button>
                                    </td>
                                  </tr>
                                </tfoot>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="column  is-narrow">
                      <div style="width: 600px; height:600px">
                        <app-map-input formControlName="GeoPolygonPoints" [BackgroundPolygonControls]="AreaBackgroundPolygons"
                        [BackgroundMarkerControls]="AreaBackgroundMarkers" MapWidth="100%" MapHeight="600"></app-map-input>
                      </div>
                    </div>
                  </div>
                </app-tab>
                <app-tab Title="Entries &amp; Exits">
                  <div class="columns">
                    <div class="column is-6">
                      <app-tree formArrayName="ParkingLots">
                        @for (lot of FormArray(Form, 'ParkingLots').controls; track lot; let lotIndex = $index) {
                          <app-treenode
                            [formGroupName]="lotIndex" [Text]="lot.get('Name')?.value" [Image]="GenerateIconName(lot)"
                            [Expanded]="true" (OnClicked)="SetMapTarget(null, null, lot)" [Selected]="lot == HighlightTarget"
                            [CanDelete]="false">
                            <div formArrayName="Levels">
                              @for (level of FormArray(lot, 'Levels').controls; track level; let levelIndex = $index) {
                                <app-treenode
                                  [formGroupName]="levelIndex" [Text]="level.get('Name')?.value" [Image]="GenerateIconName(level)"
                                  [Expanded]="true" (OnClicked)="SetMapTarget(null, null, level)" [Selected]="level == HighlightTarget"
                                  [CanDelete]="false">
                                  <div formArrayName="Gates">
                                    @for (g of FormArray(level, 'Gates').controls; track g; let gateIndex = $index) {
                                      <app-treenode
                                        [formGroupName]="gateIndex" [Text]="g.get('Name')?.value" [Image]="GenerateIconName(g)"
                                        [Expanded]="true" (OnDoubleClicked)="EditGate(g)" (OnClicked)="SetMapTarget(null, null, g)"
                                        [Selected]="g == HighlightTarget" [CanDelete]="false">
                                        <div formArrayName="Lanes">
                                          @for (l of FormArray(g, 'Lanes').controls; track l; let laneIndex = $index) {
                                            <app-treenode
                                              [formGroupName]="laneIndex"
                                              [Text]="l.get('Name')?.value + ' (' + l.get('WorkflowName')?.value + ')'"
                                              [Image]="GenerateIconName(l)" [Expanded]="true" (OnDoubleClicked)="EditLane(l, g)"
                                              (OnClicked)="SetMapTarget(null, l, g)" [Selected]="l == HighlightTarget">
                                              @if (l.get('LocalControllerId')?.value != null) {
                                                <app-treenode
                                                  [Text]="GetControllerName(l.get('LocalControllerId')?.value)"
                                                  [Image]="GenerateIconName(GetController(l.get('LocalControllerId')?.value), false)"
                                                  (OnDoubleClicked)="EditController(l.get('LocalControllerId')?.value)"
                                                  (OnClicked)="SetMapTargetController(l, g)"
                                                  [Selected]="l.get('LocalControllerId')?.value == HighlightTarget">
                                                  <app-treenode Text="Payment Devices" [Expanded]="true" formArrayName="PaymentTerminals">
                                                    @for (p of FormArray(l, 'PaymentTerminals').controls; track p; let paymentTerminalIndex = $index) {
                                                      <app-treenode
                                                        [Text]="p.get('LocalAddress')?.value" [Image]="GenerateIconName(p)" [CanExpand]="false"
                                                        (OnDoubleClicked)="EditPaymentTerminal(p)"
                                                        (OnClicked)="SetMapTargetControllerDevice(p, l, g)" [Selected]="p == HighlightTarget" [CanDelete]="true"
                                                        (OnDelete)="RemovePaymentTerminal(l, paymentTerminalIndex)">
                                                      </app-treenode>
                                                    }
                                                    <button class="button is-primary is-small" (click)="AddPaymentTerminal(l)">
                                                      <span class="icon">
                                                        <i class="fa fa-plus"></i>
                                                      </span>
                                                      <span>Add Payment Device</span>
                                                    </button>
                                                  </app-treenode>
                                                  <app-treenode Text="Displays" [Expanded]="true" formArrayName="Displays">
                                                    @for (d of FormArray(l, 'Displays').controls; track d; let displayIndex = $index) {
                                                      <app-treenode
                                                        [Text]="d.get('LocalAddress')?.value" [Image]="GenerateIconName(d)" [CanExpand]="false"
                                                        (OnDoubleClicked)="EditDisplay(d)" (OnClicked)="SetMapTargetControllerDevice(d, l, g)"
                                                        [Selected]="d == HighlightTarget" [CanDelete]="true"
                                                        (OnDelete)="RemoveDisplay(l, displayIndex)">
                                                      </app-treenode>
                                                    }
                                                    <button class="button is-primary is-small" (click)="AddDisplay(l)">
                                                      <span class="icon">
                                                        <i class="fa fa-plus"></i>
                                                      </span>
                                                      <span>Add Display</span>
                                                    </button>
                                                  </app-treenode>
                                                  <app-treenode Text="User Inputs" [Expanded]="true" formArrayName="UserInputDevices">
                                                    @for (ui of FormArray(l, 'UserInputDevices').controls; track ui; let userInputIndex = $index) {
                                                      <app-treenode
                                                        [Text]="ui.get('Name')?.value" [Image]="GenerateIconName(ui)" [CanExpand]="false"
                                                        (OnDoubleClicked)="EditUserInputDevice(ui)"
                                                        (OnClicked)="SetMapTargetControllerDevice(ui, l, g)" [Selected]="ui == HighlightTarget" [CanDelete]="true"
                                                        (OnDelete)="RemoveUserInputDevice(l, userInputIndex)">
                                                      </app-treenode>
                                                    }
                                                    <button class="button is-primary is-small" (click)="AddUserInputDevice(l)">
                                                      <span class="icon">
                                                        <i class="fa fa-plus"></i>
                                                      </span>
                                                      <span>Add User Input Device</span>
                                                    </button>
                                                  </app-treenode>
                                                </app-treenode>
                                              }
                                              <app-treenode Text="Cameras" [Expanded]="false" formArrayName="Cameras">
                                                @for (c of FormArray(l, 'Cameras').controls; track c; let cameraIndex = $index) {
                                                  <app-treenode
                                                    [Text]="c.get('LocalAddress')?.value" [Image]="GenerateIconName(c)" [CanExpand]="false"
                                                    (OnDoubleClicked)="EditCamera(c)" (OnClicked)="SetMapTarget(c, l, g)"
                                                    [Selected]="c == HighlightTarget" [CanDelete]="true"
                                                    (OnDelete)="RemoveCamera(l, cameraIndex)">
                                                  </app-treenode>
                                                }
                                                <button class="button is-primary is-small" (click)="AddCamera(g,l)">
                                                  <span class="icon">
                                                    <i class="fa fa-plus"></i>
                                                  </span>
                                                  <span>Add Camera</span>
                                                </button>
                                              </app-treenode>
                                              <app-treenode Text="Barriers" [Expanded]="false" formArrayName="Barriers">
                                                @for (b of FormArray(l, 'Barriers').controls; track b; let barrierIndex = $index) {
                                                  <app-treenode
                                                    [Text]="b.get('LocalAddress')?.value" [Image]="GenerateIconName(b)" [CanExpand]="false"
                                                    (OnDoubleClicked)="EditBarrier(b)" (OnClicked)="SetMapTarget(b, l, g)"
                                                    [Selected]="b == HighlightTarget" [CanDelete]="true"
                                                    (OnDelete)="RemoveBarrier(l, barrierIndex)">
                                                  </app-treenode>
                                                }
                                                <button class="button is-primary is-small" (click)="AddBarrier(l)">
                                                  <span class="icon">
                                                    <i class="fa fa-plus"></i>
                                                  </span>
                                                  <span>Add Barrier</span>
                                                </button>
                                              </app-treenode>
                                              <app-treenode Text="Traffic Lights" [Expanded]="false" formArrayName="TrafficLights">
                                                @for (t of FormArray(l, 'TrafficLights').controls; track t; let lightIndex = $index) {
                                                  <app-treenode
                                                    [Text]="t.get('LocalAddress')?.value" [Image]="GenerateIconName(t)" [CanExpand]="false"
                                                    (OnDoubleClicked)="EditTrafficLight(t)" (OnClicked)="SetMapTarget(t, l, g)"
                                                    [Selected]="t == HighlightTarget" [CanDelete]="true"
                                                    (OnDelete)="RemoveTrafficLight(l, lightIndex)">
                                                  </app-treenode>
                                                }
                                                <button class="button is-primary is-small" (click)="AddTrafficLight(l)">
                                                  <span class="icon">
                                                    <i class="fa fa-plus"></i>
                                                  </span>
                                                  <span>Add Traffic Light</span>
                                                </button>
                                              </app-treenode>
                                              <app-treenode Text="Cell Routers" [Expanded]="false" formArrayName="CellRouters">
                                                @for (c of FormArray(l, 'CellRouters').controls; track c; let cellRoutersIndex = $index) {
                                                  <app-treenode
                                                    [Text]="c.get('Name')?.value" [CanExpand]="false" [CanDelete]="true" (OnClicked)="SetMapTarget(c,l,g)"
                                                    (OnDoubleClicked)="EditCellRouter(c)" [Selected]="c == HighlightTarget" (OnDelete)="RemoveCellRouter(l, cellRoutersIndex)">
                                                  </app-treenode>
                                                }
                                                <button class="button is-primary is-small" (click)="AddCellRouter(l)">
                                                  <span class="icon">
                                                    <i class="fa fa-plus"></i>
                                                  </span>
                                                  <span>Add Cell Router</span>
                                                </button>
                                              </app-treenode>
                                            </app-treenode>
                                          }
                                        </div>
                                      </app-treenode>
                                    }
                                  </div>
                                </app-treenode>
                              }
                            </div>
                          </app-treenode>
                        }
                      </app-tree>
                    </div>
                    <div class="column is-6">
                      @if (MapTarget != null) {
                        <app-map-input MapWidth="100%" MapHeight="600" [Zoom]="18" [formControl]="MapTarget"
                          [Mode]="MapTargetMode" [BackgroundPolygonControls]="GateBackgroundPolygons"
                          [BackgroundMarkerControls]="GateBackgroundMarkers" (BackgroundMarkerClicked)="MapMarkerClicked($event)">
                        </app-map-input>
                      }
                    </div>
                  </div>
                </app-tab>
              </app-tabs>
            </div>
          }
